import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InspectionEditPageComponent } from '../pages/edit.component';
import { InspectionNewPageComponent } from '../pages/new.component';
import { InspectionEditJsonPageComponent } from '../pages/edit-json.component';

import { ModelSectionsPageComponent } from '../pages/importsections/index';
import { ImportSectionIndexPageComponent } from '../../shared/pages/importsections/index';
import {
  ImportPointIndexPageComponent,
  ImportPointsModelSectionsPageComponent,
  ImportPointsModelPointsPageComponent
} from '../../shared/pages/importpoints/index';

import { environment } from '../../../environments/environment';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
const appRoute = environment.applicationRoute;

const routes: Routes = [
  { path: appRoute + '/inspections/new/:isModel', component: InspectionNewPageComponent },
  {
    path: appRoute + '/inspections/:inspectionId/editjson',
    component: InspectionEditJsonPageComponent,
    resolve: { synchronizeData: SynchronizationResolver }
  },
  { path: appRoute + '/inspections/:inspectionId/edit', component: InspectionEditPageComponent },
  { path: appRoute + '/inspections/:targetId/addsection', component: ImportSectionIndexPageComponent },
  { path: appRoute + '/inspections/:targetId/addsection/:modelId', component: ModelSectionsPageComponent },
  {
    path: appRoute + '/inspections/:targetId/sections/:sectionId/addpoint/:modelId',
    component: ImportPointsModelSectionsPageComponent
  },
  {
    path: appRoute + '/inspections/:targetId/sections/:sectionId/addpoint',
    component: ImportPointIndexPageComponent
  },
  {
    path: appRoute + '/inspections/:targetId/sections/:sectionId/addpoint/:modelId/:modelSectionId',
    component: ImportPointsModelPointsPageComponent
  },
  {
    path: appRoute + '/inspections/:targetId/sections/:sectionId/folders/:folderId/addpoint/:modelId',
    component: ImportPointsModelSectionsPageComponent
  },
  {
    path: appRoute + '/inspections/:targetId/sections/:sectionId/folders/:folderId/addpoint',
    component: ImportPointIndexPageComponent
  },
  {
    path:
      appRoute + '/inspections/:targetId/sections/:sectionId/folders/:folderId/addpoint/:modelId/:modelSectionId',
    component: ImportPointsModelPointsPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InspectionEditorRoutingModule {}
export const routedComponents = [
  InspectionEditPageComponent,
  ModelSectionsPageComponent,
  InspectionEditJsonPageComponent
];
